import { Modelo } from '@ext/index';
import * as Types from './Pedido.types';
import moment, { Moment } from 'moment';
import { Cliente } from '../../Clientes';
import { Item } from './Item';
import { Envio } from '../Envios';
import { Pago } from '../Pagos';
import { Vendedor } from '@/__env/lib/Ventas/Vendedores';
import { ModificacionDeEstado } from '@/__env/lib/Ventas/Pedidos/Estados';
import { Observacion } from '@/__env/lib/Ventas/Pedidos/Observaciones';

export class IPedido extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public Tipo: Types.Tipos = Types.Tipos.Mostrador;
    public Cuenta: string = '';
    public IdExterna: number;
    public Carrito: number = 0;
    public Estado: Types.Estados = Types.Estados.Creado;
    public EstadoExterno: string = '';
    public Cliente: Cliente = new Cliente();
    public Vendedor: Vendedor = new Vendedor();

    public Envio: Envio = new Envio();
    public Tags: Tags = new Tags();
    public Fecha: Moment = moment();

    public Items: Array<Item> = [];
    public Pagos: Array<Pago> = [];
    public Historial: ModificacionDeEstado[] = [];
    public Observaciones: Observacion[] = [];

    public HabilitaPagoPresencial: boolean = false;

    public NoAplicaIIBB: boolean = false;
    public DeclaracionBienDeUso: string = '';

    public EstadosPermitidos: Array<Types.Estados> = [];

    public Importes: Importes = {
        Neto: 0,
        Final: 0,
        FinalConEnvio: 0,
        Pagado: 0,
        Iva: 0,
        EnvioNeto: 0,
        EnvioFinal: 0,
        Descuento: 0,
        Percepciones: 0,
    };

    public CodigoAleatorio: string = '';

    public Moneda: string = 'ARS';
    public Cotizacion: number = 1;
    public Urls = {
        NotaDeVenta: '',
        ReciboMercadoPago: ''
    };

    public get FacturaA()
    {
        return !this.Cliente.CondicionIva.esConsumidorFinal;
    }

    public getJson(): any
    {
        let json: any = {};

        json.tipo = this.Tipo.Id;
        if ( !this.Cuenta )
        {
            json.cuenta = null;
        } else
        {
            json.cuenta = this.Cuenta;

        }

        json.id_externa = this.IdExterna;
        json.carrito = this.Carrito;
        json.estado = this.Estado.Id;
        json.estado_externo = this.EstadoExterno;
        json.cliente = this.Cliente.Id;
        json.vendedor = this.Vendedor.Id;
        json.envio = this.Envio.Id ? this.Envio.Id : null;
        json.fecha = this.Fecha.toSQL();
        //json.importe_neto = this.Importes.Neto;
        //json.importe_final = this.Importes.Final;
        //json.importe_final_con_envio = this.Importes.FinalConEnvio;
        //json.importe_pagado = this.Importes.Pagado;
        json.moneda = this.Moneda;
        json.cotizacion = this.Cotizacion;
        //json.importe_iva = this.Importes.Iva;
        //json.importe_neto_envio = this.Importes.EnvioNeto;
        //json.importe_final_envio = this.Importes.EnvioFinal;
        //json.importe_descuento = this.Importes.Descuento;
        json.codigo_aleatorio = this.CodigoAleatorio;



        json.items = this.Items.map( x => x.getJson() );
        return json;
    }

    public set(): boolean
    {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Tipo = Types.Tipos.toTipo( this.Json.tipo );
        this.Cuenta = this.Json.cuenta;
        this.CodigoAleatorio = !this.Json.codigo_aleatorio ? '' : this.Json.codigo_aleatorio;
        this.IdExterna = this.Json.id_externa;
        this.Carrito = this.Json.carrito;
        this.Estado = Types.Estados.toTipo( this.Json.estado );
        this.EstadoExterno = this.Json.estado_externo;

        this.HabilitaPagoPresencial = this.Json.habilita_pago_presencial == 'S';

        this.NoAplicaIIBB = this.Json.no_aplica_iibb == 'S';
        this.DeclaracionBienDeUso = !this.Json.declaracion_iibb ? '' : this.Json.declaracion_iibb;

        if ( this.Json.items && Array.isArray( this.Json.items ) )
        {
            this.Items.clear();
            this.Items.push( ...this.Json.items.map( ( x: any ) => new Item( x ) ) );
        }

        if ( this.Json.cliente )
        {
            this.Cliente = new Cliente( this.Json.cliente );
        }

        if ( this.Json.vendedor )
        {
            this.Vendedor = new Vendedor( this.Json.vendedor );
        }

        if ( this.Json.envio )
        {
            this.Envio = new Envio( this.Json.envio );
        }

        if ( this.Json.permite && Array.isArray( this.Json.permite ) )
        {

            this.EstadosPermitidos.clear();
            this.EstadosPermitidos.push( ... this.Json.permite.map( ( x: string ) => Types.Estados.toTipo( x ) ) );
        }



        if ( this.Json.tags )
        {
            this.Tags.Pendiente = this.Json.tags.pendiente == 'S';
            this.Tags.Despachado = this.Json.tags.despachado == 'S';
            this.Tags.Pagado = this.Json.tags.pagado;
            this.Tags.Facturado = this.Json.tags.facturado == 'S';
            this.Tags.Finalizado = this.Json.tags.finalizado == 'S';
            this.Tags.Demorado = this.Json.tags.demorado == 'S';
            this.Tags.DespacharHoy = this.Json.tags.despachar_hoy == 'S';
            this.Tags.CodigosDesconocidos = this.Json.tags.codigos_desconocidos == 'S';
            this.Tags.EnvioValido = this.Json.tags.envio_valido == 'S';
            this.Tags.EnvioOptimo = moment( this.Json.tags.envio_optimo );
            this.Tags.TrackingCargado = this.Json.tags.envio_tracking_cargado;
            this.Tags.HojaDePiso = this.Json.tags.hoja_de_piso;
            this.Tags.Canasto = this.Json.canasto;
            this.Tags.Llamados = this.Json.tags.llamado;

            this.Tags.Fechas.Creado = !this.Json.tags.fecha ? moment( '' ) : moment( this.Json.tags.fecha );
            this.Tags.Fechas.Facturado = !this.Json.tags.fecha_facturado ? moment( '' ) : moment( this.Json.tags.fecha_facturado );
            this.Tags.Fechas.Despachado = !this.Json.tags.fecha_despachado ? moment( '' ) : moment( this.Json.tags.fecha_despachado );
            this.Tags.Fechas.Finalizado = !this.Json.tags.fecha_finalizado ? moment( '' ) : moment( this.Json.tags.fecha_finalizado );

            this.Tags.Fechas.Demora = this.Tags.Fechas.Despachado.from( this.Tags.Fechas.Creado);

            this.Tags.Procesos.Confirmacion = new ProcesoAutomatico( this.Json.tags.confirmacion_enviado, this.Json.tags.fecha_confirmacion_enviado );
            this.Tags.Procesos.Factura = new ProcesoAutomatico( this.Json.tags.factura_enviada, this.Json.tags.fecha_factura_enviada );
            this.Tags.Procesos.Despacho = new ProcesoAutomatico( this.Json.tags.despacho_enviado, this.Json.tags.fecha_despacho_enviado );
            this.Tags.Procesos.Entrega = new ProcesoAutomatico( this.Json.tags.entregado_enviado, this.Json.tags.fecha_entregado_enviado );
            this.Tags.Procesos.Manuales = new ProcesoAutomatico( this.Json.tags.manuales_enviado, this.Json.tags.fecha_manuales_enviado );
        }


        this.Fecha = !this.Json.fecha ? moment( '' ) : moment( this.Json.fecha );
        this.Importes.Neto = !this.Json.importe_neto ? 0 : this.Json.importe_neto;
        this.Importes.Final = !this.Json.importe_final ? 0 : this.Json.importe_final;
        this.Importes.FinalConEnvio = !this.Json.importe_final_con_envio ? 0 : this.Json.importe_final_con_envio;
        this.Importes.Pagado = !this.Json.importe_pagado ? 0 : this.Json.importe_pagado;
        this.Moneda = !this.Json.moneda ? 'ARS' : this.Json.moneda;
        this.Cotizacion = !this.Json.cotizacion ? 0 : this.Json.cotizacion;
        this.Importes.Iva = !this.Json.importe_iva ? 0 : this.Json.importe_iva;
        this.Importes.EnvioNeto = !this.Json.importe_neto_envio ? 0 : this.Json.importe_neto_envio;
        this.Importes.EnvioFinal = !this.Json.importe_final_envio ? 0 : this.Json.importe_final_envio;
        this.Importes.Descuento = !this.Json.importe_descuento ? 0 : this.Json.importe_descuento;
        this.Importes.Percepciones = !this.Json.importe_percepciones ? 0 : this.Json.importe_percepciones;
        //this.Importes.Percepciones = !this.Json.importe_percepciones ? 0 : this.Json.percepciones;

        this.Urls.NotaDeVenta = !this.Json.notadeventa ? '' : this.Json.notadeventa;
        this.Urls.ReciboMercadoPago = !this.Json.recibo_mp ? '' : this.Json.recibo_mp;

        this.Existe = true;
        return this.Existe;
    }


    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IPedido )
    {
        this.Model = Model;
    }

    public Model: IPedido;

    public get Imagen(): string
    {
        if ( this.Model.Items.hasRows() )
        {
            return this.Model.Items[0].Imagen;
        }
        return '';
    }
}


type Importes = {
    Neto: number,
    Final: number,
    FinalConEnvio: number,
    Pagado: number,
    EnvioNeto: number,
    EnvioFinal: number,
    Descuento: number,
    Iva: number,
    Percepciones:number,
};

export class Tags
{

    public Pendiente: boolean = false;
    public Despachado: boolean = false;
    public Pagado: string = 'I';
    public Facturado: boolean = false;
    public Finalizado: boolean = false;
    public EnvioOptimo: Moment;
    public TrackingCargado: string = 'I';
    public Demorado: boolean = false;
    public DespacharHoy: boolean = false;
    public CodigosDesconocidos: boolean = false;
    public EnvioValido: boolean = false;
    public HojaDePiso: number = null;
    public Canasto: string = null;
    public Llamados: string = '';

    public Fechas: { Creado: Moment, Demora: string, Facturado: Moment, Despachado: Moment, Finalizado: Moment, } = { Demora: null, Creado: null, Despachado: null, Facturado: null, Finalizado: null, };
    public Procesos: {
        Confirmacion?: ProcesoAutomatico,
        Factura?: ProcesoAutomatico,
        Despacho?: ProcesoAutomatico,
        Manuales?: ProcesoAutomatico,
        Entrega?: ProcesoAutomatico,
    } = {
            Confirmacion: new ProcesoAutomatico( 'pendiente', null ),
            Despacho: new ProcesoAutomatico( 'pendiente', null ),
            Entrega: new ProcesoAutomatico( 'pendiente', null ),
            Factura: new ProcesoAutomatico( 'pendiente', null ),
            Manuales: new ProcesoAutomatico( 'pendiente', null ),
        }
}

export class ProcesoAutomatico
{
    constructor( estado: string, fecha: string )
    {
        this.Estado = estado;
        this.Fecha = fecha ? moment(fecha) : moment('');
    }

    public Estado: string;
    public Fecha: Moment;
}